/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function rgbaFilter(): angular.IFilterService {
        const filter = (input: any) : any => {
            if (!input) {
                return "auto";
            }

            let nh = (input.charAt(0) == "#") ? input.substr(1, input.length - 1) : input;
            let adder = nh.length > 6 ? 2 : 0;
            let A = nh.length > 6 ? parseInt(nh.substr(0, 2), 16) : 255;
            let R = parseInt(nh.substr(0 + adder, 2), 16);
            let G = parseInt(nh.substr(2 + adder, 2), 16);
            let B = parseInt(nh.substr(4 + adder, 2), 16);

            return "rgba(" + R + "," + G + "," + B + "," + A + ")";
        };

        return filter;
    }


    angular.module("meevo.components.filters")
        .filter("rgba", rgbaFilter);
}
